import { useState, useCallback, useMemo } from "react";
import BreakdownDialog from "./BreakdownDialog";

export const LEASE_AMENDMENT_ACTIVITY_BREAKDOWN_COLUMNS = [
  { key: "msn", label: "MSN" },
  { key: "operator", label: "Operator" },
  { key: "amendment_count", label: "Amendments", mono: true },
];

// Drives the "Lease Amendment Activity" popup: clicking a point on the line
// filters the flat breakdown rows down to that month.
export function useLeaseAmendmentActivityBreakdown({ breakdown, onTrack }) {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const reset = useCallback(() => {
    setSelectedMonth(null);
    setModalOpen(false);
  }, []);

  const allRows = useMemo(() => (Array.isArray(breakdown) ? breakdown : []), [breakdown]);
  const canRender = allRows.length > 0;

  const rows = useMemo(() => {
    if (!selectedMonth) return allRows;
    return allRows.filter((row) => row?.month === selectedMonth);
  }, [allRows, selectedMonth]);

  const handleChartClick = useCallback(
    (params) => {
      if (!params || params.componentType !== "series") return;
      const month = params.name || null;
      setSelectedMonth(month);
      setModalOpen(true);
      onTrack?.(`Graph Point Clicked: ${month || ""}`);
    },
    [onTrack],
  );

  const chartEvents = useMemo(() => ({ click: handleChartClick }), [handleChartClick]);

  const closeModal = useCallback(() => setModalOpen(false), []);

  const titleSuffix = useMemo(() => selectedMonth || "", [selectedMonth]);

  return { rows, canRender, chartEvents, modalOpen, closeModal, titleSuffix, reset };
}

export function LeaseAmendmentActivityBreakdownModal({ open, onClose, rows, titleSuffix }) {
  const title = "Lease Amendment Activity";
  return (
    <BreakdownDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={titleSuffix}
      columns={LEASE_AMENDMENT_ACTIVITY_BREAKDOWN_COLUMNS}
      rows={rows}
    />
  );
}
